import { observer } from 'mobx-react-lite';
import React from 'react';
import * as Styled from './AccidentSection.styled';
import Item from '../ClickableItem';
import moment from 'moment';
import { IAccident } from 'store/mobx/myHealthStore/myHealthStore.type';

interface IAccidentsProps {
    header: string;
    title: string,
    accidents: IAccident[],
}

function getTooltipText(item: IAccident) {
    if (item.AccidentNumber) {
        return [`Accident Number: ${item.AccidentNumber}`, `Status: ${item.Status}`, `Date: ${moment(item.AccidentDateTime).format('DD/MM/YYYY')}`, `Insurer: ${item.Insurer}`, `Description: ${item.Description}`, `Diagnosis: ${item.Description}`, `Practitioner: ${item.ProviderName}`];
    }
    return [];
}

const AccidentSection: React.FC<IAccidentsProps> = observer(({ header, title, accidents }) => {
    return (
    <div>
        {accidents?.length > 0 &&
            <Styled.Container>
                <Styled.Header>{header}</Styled.Header>
                <Styled.Card>
                    <Styled.Section>
                        <Styled.Title>{title}</Styled.Title>
                        {accidents.length === 0 && <Styled.NoContent>No Records Found</Styled.NoContent>}
                        {accidents.length > 0 &&
                            accidents.map((item: any) =>
                                <Item
                                    onClick={(keyword: string) => {
                                        window.open(`https://healthify.nz/search/results#stq=${keyword}&stp=1`)
                                    }}
                                    text={item.Description}
                                    tooltipText={getTooltipText(item)}
                                    date={item.AccidentDateTime}
                                />
                            )
                        }
                    </Styled.Section>
                </Styled.Card>
            </Styled.Container>
        }
    </div>
    )
})

export default AccidentSection;

